import { render, staticRenderFns } from "./SyllabusesListDetails.vue?vue&type=template&id=2025784c&scoped=true&"
import script from "./SyllabusesListDetails.vue?vue&type=script&lang=js&"
export * from "./SyllabusesListDetails.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusesListDetails.vue?vue&type=style&index=0&id=2025784c&scoped=true&lang=scss&"
import style1 from "./SyllabusesListDetails.vue?vue&type=style&index=1&id=2025784c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025784c",
  null
  
)

export default component.exports